// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { DeleteMultipleMarketsRequestToJSON, } from '../models';
/**
 * Delete multiple markets endpoint (deprecated - use POST /markets/delete instead)
 * Delete markets
 */
export function deleteMarketsRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/markets` + queryString,
        meta,
        update: requestConfig.update || {
            DeleteMarkets: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            DeleteMarkets: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            DeleteMarkets: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'DELETE',
            headers: headerParameters,
        },
        body: DeleteMultipleMarketsRequestToJSON(requestParameters.deleteMultipleMarketsRequest),
    };
    config.queryKey = requestConfig.queryKey || `DeleteMarkets-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Delete multiple markets endpoint (deprecated - use POST /markets/delete instead)
* Delete markets
*/
export function deleteMarkets(requestParameters, requestConfig) {
    return deleteMarketsRaw(requestParameters, requestConfig);
}
/**
 * Bulk delete markets endpoint (preferred method following REST standards)
 * Delete markets (bulk)
 */
export function postMarketsDeleteRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/markets/delete` + queryString,
        meta,
        update: requestConfig.update || {
            DeleteMarkets: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            DeleteMarkets: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            DeleteMarkets: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: DeleteMultipleMarketsRequestToJSON(requestParameters.deleteMultipleMarketsRequest),
    };
    config.queryKey = requestConfig.queryKey || `PostMarketsDelete-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Bulk delete markets endpoint (preferred method following REST standards)
* Delete markets (bulk)
*/
/**
 * Mutation hook to upsert an
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an
 */
export const usePostMarketsDelete = (customQueryConfig) => {
    return useMutation((deleteMultipleMarketsRequest, customQueryParam) => postMarketsDeleteRaw({ deleteMultipleMarketsRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postMarketsDelete(requestParameters, requestConfig) {
    return postMarketsDeleteRaw(requestParameters, requestConfig);
}
